import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import React from 'react';
import { ThemedIcon } from './ThemedIcon';
import { ControlsTheme, getThemeStyles } from './controls-theme';

interface VolumeControlProps {
  volume: number;
  isMuted: boolean;
  onToggleMute: () => void;
  onVolumeChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  color?: string;
  theme?: ControlsTheme;
  /** Mostra a barra (slider) de volume ao lado do botão. Usado no tema Safari,
   *  onde os skips saíram do rodapé e o volume ocupa esse espaço. */
  showSlider?: boolean;
}

export const VolumeControl: React.FC<VolumeControlProps> = ({
  volume,
  isMuted,
  onToggleMute,
  onVolumeChange,
  color = '#FFFFFF',
  theme = 'minimal',
  showSlider = false,
}) => {
  useLanguage();
  const { wrapperClass } = getThemeStyles(theme, color);
  const muted = isMuted || volume === 0;

  const button = (
    <button onClick={onToggleMute} className={wrapperClass} style={{ color }}>
      <ThemedIcon name={muted ? 'volumeX' : 'volume'} theme={theme} className="h-5 w-5" />
    </button>
  );

  if (!showSlider) return button;

  return (
    <div className="flex items-center gap-2">
      {button}
      <input
        type="range"
        min={0}
        max={1}
        step={0.01}
        value={muted ? 0 : volume}
        onChange={onVolumeChange}
        aria-label={translateInterfaceText("Volume")}
        className="h-1 w-20 cursor-pointer"
        style={{ accentColor: color }}
      />
    </div>
  );
};
